import React from 'react';

export const FooterMenu = () => {
    return (
        <div id="menu_footer">
            <div className="wrap bloc_SEI">
                <div className="menu">
                    <p className="titre_liste">
                        Les services But
                    </p>
                    <ul>
                        <li>
                            <p className="sous_titre_liste">
                                Mes solutions de paiement
                            </p>
                            <ul>
                                <li><a href="/Carte_but" className="a_brouille c_brouille">Réglez avec la Carte BUT CPAY
                                    MASTERCARD</a></li>
                                <li><a href="/aide?_eptssref=/fr-fr/50/paiement-et-financement/" className="a_brouille c_brouille">Cartes
                                    cadeaux BUT et chèques partenaires</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Mes modes de livraison/retrait
                            </p>
                            <ul>
                                <li><a href="/Services/Page/Retrait-2h" className="a_brouille c_brouille">Retrait
                                    gratuit</a></li>
                                <li><a href="/Services/Page/Livraison-domicile" className="a_brouille c_brouille">Livraison
                                    et montage</a></li>
                                <li><a href="/Services/Page/Camionnette" className="a_brouille c_brouille">Location de
                                    camionnette</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Mes garanties
                            </p>
                            <ul>
                                <li><a href="/Services/Page/Sav" className="a_brouille c_brouille">SAV</a></li>
                                <li><a href="/a/1-Eco-Mobilier" className="a_brouille c_brouille">Recyclage et reprise
                                    Mobilier</a></li>
                                <li><a href="/a/41-Eco-Electromenager" className="a_brouille c_brouille">Recyclage et
                                    reprise Electroménager</a></li>
                                <li><a href="https://media.but.fr/PDF/N_SYDEREP_Magasins_BUT.pdf" target="_blank" className="a_brouille c_brouille">N°&nbsp;Registre de suivi Ademe/Ecomobilier</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="menu">
                    <p className="titre_liste">
                        Les + But
                    </p>
                    <ul className="liste">
                        <li>
                            <p className="sous_titre_liste">
                                Mon inspiration
                            </p>
                            <ul>
                                <li><a href="https://blog.but.fr/" target="_blank" className="a_brouille c_brouille">Blog
                                    BUT</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Mes bons plans
                            </p>
                            <ul>
                                <li><a href="/Carte_but" className="a_brouille c_brouille">Tous les avantages de la
                                    Carte BUT</a></li>
                                <li><a href="/actualites/les-catalogues-but" className="a_brouille c_brouille">Dépliants
                                    et catalogue</a></li>
                                <li><a href="/newsletter/programme_fidelite/inscription"
                                       className="a_brouille c_brouille">Programme de fidélité</a></li>
                                <li><a href="https://monavantage.but.fr/" target="_blank"
                                       className="a_brouille c_brouille">Offres Mes avantages BUT</a></li>
                                <li><a href="https://monavantage.but.fr/" target="_blank"
                                       className="a_brouille c_brouille">Réclamation Offre de remboursement</a></li>
                                <li><a href="http://lesrendezvous.but.fr/" target="_blank"
                                       className="a_brouille c_brouille">Les rendez-vous BUT</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Mes projets
                            </p>
                            <ul>
                                <li>
                                </li>
                                <li><a href="http://www.but-cuisines.fr/" target="_blank" className="a_brouille c_brouille">Projet Cuisine</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste commandables">
                                <a href="/themes/commandables-express/index-c488517.html"
                                   className="a_brouille c_brouille">Commandables Express</a>
                            </p>
                        </li>
                    </ul>
                </div>
                <div className="menu">
                    <p className="titre_liste">
                        But &amp; moi
                    </p>
                    <ul className="liste">
                        <li>
                            <p className="sous_titre_liste">
                                Besoin d’aide ?
                            </p>
                            <ul>
                                <li><a href="#" id="Footer_HorsTunnel_Lien_Aide_et_Contact_dialonce-widget" className="a_brouille c_brouille">Aide &amp; Contact</a></li>
                                <li><a href="/aide" className="a_brouille c_brouille">Questions fréquentes</a></li>
                                <li><a href="/Informations/Conditions-generales" className="a_brouille c_brouille">CGV
                                    Internet</a></li>
                                <li><a href="https://media.but.fr/PDF/CGV-BUT-Magasins-Decembre2019.pdf" target="_blank"
                                       className="a_brouille c_brouille">CGV magasin</a></li>
                                <li><a href="/Common/Services/Accessibility" target="_blank"
                                       id="access" className="a_brouille c_brouille">Accessibilité</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Informations
                            </p>
                            <ul>
                                <li><a href="https://media.but.fr/PDF/Rappel_produit_en_cours.pdf"
                                       target="_blank">Rappel produits</a></li>
                                <li><a href="https://recrute.but.fr/postulez" target="_blank" className="a_brouille c_brouille">BUT recrute</a></li>
                                <li><a href="/but-pro" target="_blank" className="gtm-footer-link">But Pro</a></li>
                                <li><a href="https://But-corporate.fr" target="_blank" className="a_brouille c_brouille">But-corporate.fr</a></li>
                                <li><a href="/Informations/Mentions-legales" className="a_brouille c_brouille">Mentions
                                    légales</a></li>
                                <li><a href="/Common/Services/DonneesPersonnelles" className="a_brouille c_brouille">Données
                                    personnelles</a></li>
                                <li><a href="#" onClick={() => {
                                    tC.privacyCenter.showPrivacyCenter();
                                    return false
                                }}
                                       className="a_brouille c_brouille">Gérer mes cookies</a></li>
                                <li><a href="/aide/plan-site.php" className="a_brouille c_brouille">Plan du site</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div className="menu">
                    <p className="titre_liste">
                        Marketplace
                    </p>
                    <ul className="liste">
                        <li>
                            <p className="sous_titre_liste">
                                Informations
                            </p>
                            <ul>
                                <li><a href="/marketplace-but" className="a_brouille c_brouille">Qu'est-ce que la
                                    Marketplace ?</a></li>
                                <li><a href="/marketplace-vendeurs" className="a_brouille c_brouille">Vendre sur la
                                    Marketplace But</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="sous_titre_liste">
                                Aide sur la Marketplace
                            </p>
                            <ul>
                                <li><a href="https://media.but.fr/PDF/BUT_CGV_Marketplace.pdf" target="_blank"
                                       className="a_brouille c_brouille">CGV Marketplace</a></li>
                                <li><a href="https://media.but.fr/PDF/BUT_CGU_Marketplace.pdf" target="_blank"
                                       className="a_brouille c_brouille">CGU Marketplace</a></li>
                                <li><a href="https://media.but.fr/PDF/BUT_CGU_prestataire_paiement.pdf" target="_blank"
                                       className="a_brouille c_brouille">Prestataire de paiement</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="titre_liste">Publicité</p>
                            <ul>
                                <li><a href="https://retailium-media.com/" target="_blank"
                                       className="a_brouille c_brouille">Retailium Média</a></li>
                            </ul>
                        </li>
                        <li>
                            <p className="titre_liste">
                                Les marques exclusives
                            </p>
                            <ul>
                                <li><a href="https://www.lineanatura.fr/" target="_blank"
                                       className="a_brouille c_brouille">Linea Natura</a></li>
                                <li><a href="https://www.modern-living.fr/" target="_blank"
                                       className="a_brouille c_brouille">Modern Living</a></li>
                                <li><a href="https://www.time-collection.fr/" target="_blank"
                                       className="a_brouille c_brouille">Time</a></li>
                                <li><a href="https://www.zandiara.fr/" target="_blank"
                                       className="a_brouille c_brouille">Zandiara</a></li>
                                <li><a href="https://www.bxgaming.fr/" target="_blank"
                                       className="a_brouille c_brouille">BX Gaming</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="socials_networks">
                <p>Suivez-nous sur les réseaux !</p>
                <ul>
                    <li>
                        <a rel="noopener noreferrer" title="Instagram" target="_blank" className="a_brouille"
                           href="https://www.instagram.com/but/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="29.994" height={30} viewBox="0 0 29.994 30">
                                <g transform="translate(0 0)">
                                    <path
                                        d="M30.366,8.82a10.962,10.962,0,0,0-.7-3.639A7.685,7.685,0,0,0,25.279.791a10.99,10.99,0,0,0-3.639-.7C20.034.018,19.524,0,15.451,0S10.869.018,9.269.088a10.965,10.965,0,0,0-3.639.7A7.32,7.32,0,0,0,2.969,2.52,7.386,7.386,0,0,0,1.24,5.175a10.991,10.991,0,0,0-.7,3.639C.466,10.42.449,10.93.449,15s.018,4.583.088,6.183a10.961,10.961,0,0,0,.7,3.639,7.684,7.684,0,0,0,4.389,4.389,10.992,10.992,0,0,0,3.639.7c1.6.071,2.11.088,6.183.088s4.583-.017,6.183-.088a10.959,10.959,0,0,0,3.639-.7,7.673,7.673,0,0,0,4.39-4.389,11,11,0,0,0,.7-3.639c.07-1.6.088-2.11.088-6.183s-.006-4.583-.076-6.183Zm-2.7,12.248a8.223,8.223,0,0,1-.516,2.784A4.976,4.976,0,0,1,24.3,26.7a8.252,8.252,0,0,1-2.784.516c-1.582.071-2.057.088-6.06.088s-4.483-.017-6.06-.088A8.218,8.218,0,0,1,6.614,26.7a4.616,4.616,0,0,1-1.723-1.119,4.664,4.664,0,0,1-1.119-1.723,8.253,8.253,0,0,1-.516-2.784c-.071-1.582-.088-2.057-.088-6.06s.017-4.483.088-6.06a8.218,8.218,0,0,1,.516-2.784A4.56,4.56,0,0,1,4.9,4.448,4.657,4.657,0,0,1,6.62,3.329,8.258,8.258,0,0,1,9.4,2.813c1.582-.07,2.057-.088,6.06-.088s4.483.018,6.06.088a8.223,8.223,0,0,1,2.784.516A4.613,4.613,0,0,1,26.03,4.448a4.663,4.663,0,0,1,1.119,1.723,8.256,8.256,0,0,1,.516,2.784c.07,1.582.088,2.057.088,6.06s-.018,4.472-.088,6.054Zm0,0"
                                        transform="translate(-0.449 0)" fill="#fff"/>
                                    <path
                                        d="M132.427,124.5a7.478,7.478,0,1,0,7.478,7.478A7.48,7.48,0,0,0,132.427,124.5Zm0,12.329a4.851,4.851,0,1,1,4.851-4.851A4.852,4.852,0,0,1,132.427,136.829Zm0,0"
                                        transform="translate(-117.424 -116.975)" fill="#fff"/>
                                    <path
                                        d="M366.161,90.457a1.856,1.856,0,1,1-1.856-1.856A1.856,1.856,0,0,1,366.161,90.457Zm0,0"
                                        transform="translate(-341.325 -83.432)" fill="#fff"/>
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" title="Pinterest" target="_blank" className="a_brouille"
                           href="http://pinterest.com/magasinsbut/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24.374" height={30} viewBox="0 0 24.374 30">
                                <path
                                    d="M14.845,0C6.621,0,2.25,5.27,2.25,11.015c0,2.664,1.489,5.988,3.873,7.041.68.306.59-.067,1.175-2.305a.531.531,0,0,0-.128-.521C3.763,11.289,6.505,3.186,14.359,3.186c11.366,0,9.243,15.728,1.978,15.728a2.682,2.682,0,0,1-2.826-3.289c.535-2.166,1.583-4.5,1.583-6.056,0-3.935-5.863-3.351-5.863,1.863a6.307,6.307,0,0,0,.57,2.7s-1.886,7.62-2.236,9.044c-.593,2.41.08,6.311.139,6.648a.2.2,0,0,0,.36.091,23.572,23.572,0,0,0,3.105-5.848c.233-.856,1.186-4.331,1.186-4.331a5.183,5.183,0,0,0,4.373,2.085c5.745,0,9.9-5.05,9.9-11.316C26.6,4.5,21.463,0,14.845,0Z"
                                    transform="translate(-2.25 0)" fill="#fff"/>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" title="Tik-Tok" target="_blank" href="https://www.tiktok.com/@magasinsbut" className="a_brouille">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26.374" height="30" viewBox="0 0 24 24">
                            <path 
                                d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" 
                                transform="translate(0 0)" fill="#fff"></path>
                        </svg>
                        </a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" title="Facebook" target="_blank" className="a_brouille"
                           href="http://www.facebook.com/but">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.211" height="25.625"
                                 viewBox="0 0 13.211 25.625">
                                <g transform="translate(0 0)">
                                    <path
                                        d="M215.583,102.789v-11.6h3.91l.586-4.54h-4.5V83.758c0-1.311.364-2.205,2.245-2.205h2.383V77.5a32.044,32.044,0,0,0-3.493-.178c-3.456,0-5.822,2.109-5.822,5.984v3.341H207v4.54h3.9v11.76Zm0,.161"
                                        transform="translate(-207 -77.324)" fill="#fff"/>
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a rel="noopener noreferrer" title="Twitter" target="_blank" href="https://twitter.com/But" className="a_brouille">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28.565" height="23.208"
                                 viewBox="0 0 28.565 23.208">
                                <path
                                    d="M28.565,50.748a12.209,12.209,0,0,1-3.374.925,5.823,5.823,0,0,0,2.576-3.237,11.7,11.7,0,0,1-3.713,1.418,5.856,5.856,0,0,0-10.13,4,6.03,6.03,0,0,0,.136,1.335,16.576,16.576,0,0,1-12.07-6.125,5.857,5.857,0,0,0,1.8,7.827,5.783,5.783,0,0,1-2.646-.721v.064a5.883,5.883,0,0,0,4.692,5.754,5.845,5.845,0,0,1-1.535.193,5.178,5.178,0,0,1-1.109-.1,5.912,5.912,0,0,0,5.472,4.079,11.767,11.767,0,0,1-7.261,2.5,10.97,10.97,0,0,1-1.4-.08,16.486,16.486,0,0,0,8.984,2.628c10.776,0,16.668-8.926,16.668-16.664,0-.259-.009-.509-.021-.757A11.682,11.682,0,0,0,28.565,50.748Z"
                                    transform="translate(0 -48)" fill="#fff"/>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
};
export default FooterMenu;